<template>
    <LoginRedirect :currentStep="0" :allDone="false" />
</template>

<script>
// Branded enterprise SSO entry (Epic CORE-6317 F9): /{slug}/login.
// Kicks off an OIDC sign-in tagged with the customer slug so the Identity Server
// routes to its branded /{slug}/login → Entra. Mirrors the IS-side /{slug}/login route.
import { normalizeSsoSlug } from '@/utils/ssoSlug';
import LoginRedirect from '../../../components/LoginRedirect';

export default {
    components: { LoginRedirect },
    async created() {
        const slug = normalizeSsoSlug(this.$route.params.slug);
        if (!slug) {
            // Not a slug the Identity Server could resolve — use the standard flow.
            this.$router.replace({ path: '/' });
            return;
        }

        // Already signed in (the OIDC session was restored, or seamless cross-portal
        // auth found one). Just go to the app and deliberately do NOT persist the slug:
        // a URL param must not retroactively brand an already-authenticated session. A
        // non-SSO user who opens a stale or another tenant's /{slug}/login would
        // otherwise get l2u:ssoSlug written to their browser, and every later token-expiry
        // re-auth routed to an Entra tenant they cannot pass. The slug is only persisted
        // when we actively start an SSO sign-in below.
        if (await window.auth.isLoggedIn()) {
            this.$router.replace({ path: '/' });
            return;
        }

        try {
            await window.auth.loginWithSso(slug);
        } catch (e) {
            console.error('SSO login initiation failed:', e);
            this.$router.push({ path: '/login' });
        }
    }
};
</script>
